import {
  ADD_DEPARTMENT_OPTIONS,
  ADD_EMPLOYEES_OPTIONS,
  ADD_SECTION_OPTIONS,
  ADD_ANDROID_ID_OPTIONS_FOR_UIPPS,
  DELETE_SELECT_OPTIONS,
  INIT_OPTIONS,
  ADD_RAILCHAIN_OPTIONS,
  ADD_ANDROID_ID_OPTIONS_FOR_IUR,
  ADD_DIRECTORATES_UIPPS_OPTIONS,
  ADD_DIRECTORATES_OPTIONS,
  ADD_BRIGADES_OPTIONS,
  ADD_POSITION,
  UPDATE_OPTIONS_LABELS,
  ADD_ROLES_OPTIONS,
  ADD_ROADS_OPTIONS,
} from '../type';

export function optionsReducer(state = {}, action) {
  const { type, payload } = action;

  switch (type) {
    case INIT_OPTIONS: {
      let options = payload;
      return {
        ...options,
        ...(state?.status ? { status: state.status } : {}),
        ...(state?.condition ? { condition: state.condition } : {}),
        ...(state?.optionsActions ? { optionsActions: state?.optionsActions } : {}),
        ...(state?.optionsDateSort ? { optionsDateSort: state?.optionsDateSort } : {}),
        ...(state?.optionsSemaphoreDirection ? { optionsSemaphoreDirection: state?.optionsSemaphoreDirection } : {}),
        ...(state?.mrmIds ? { mrmIds: state?.mrmIds } : {}),
      };
    }
    case ADD_ROADS_OPTIONS: {
      return { ...state, roads: payload };
    }
    case ADD_ROLES_OPTIONS: {
      return { ...state, roles: payload };
    }
    case ADD_DEPARTMENT_OPTIONS: {
      return { ...state, departments: payload };
    }

    case ADD_BRIGADES_OPTIONS: {
      return { ...state, brigadeNames: payload };
    }

    case ADD_DIRECTORATES_UIPPS_OPTIONS: {
      return { ...state, directoratesUipps: payload };
    }

    case ADD_DIRECTORATES_OPTIONS: {
      return { ...state, directorates: payload };
    }

    case ADD_ANDROID_ID_OPTIONS_FOR_UIPPS: {
      return { ...state, uippsAndroidId: payload };
    }

    case ADD_ANDROID_ID_OPTIONS_FOR_IUR: {
      return { ...state, iurAndroidId: payload };
    }

    case ADD_EMPLOYEES_OPTIONS: {
      return { ...state, workers: payload };
    }

    case ADD_SECTION_OPTIONS: {
      return { ...state, stations: payload };
    }

    case DELETE_SELECT_OPTIONS: {
      return { ...state, payload: [] };
    }

    case ADD_RAILCHAIN_OPTIONS: {
      let { railChainsPerStation = {} } = state;
      railChainsPerStation[payload.station] = payload.data;
      return { ...state, railChainsPerStation: { ...railChainsPerStation } };
    }

    case ADD_POSITION: {
      return { ...state, positions: payload };
    }

    // меняем локальные опции для селектов при смене языка
    case UPDATE_OPTIONS_LABELS: {
      return {
        ...state,
        ...payload,
      };
    }

    default:
      return state;
  }
}
